module.exports = __webpack_public_path__ + "media/site_templates/www.carpetcleaning.agency/images/our_services_1-284ac35b37bf0a0a3e1934e18fe3b5b0.jpg";